import React from 'react';

import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { ModalObserver } from '../modal-observer';
import { LoginModalContainer } from './login-modal-container';

export const Login = ({ name }) => (
  <ModalObserver name={name}>
    {(props) => (
      <ModalWrapper {...props}>
        <LoginModalContainer {...props} />
      </ModalWrapper>
    )}
  </ModalObserver>
);
